/* GDPR Notice Script
 * This script checks if the user is from the EU using Cloudflare's CF-IPCountry header
 * and displays a GDPR consent banner if needed.
 */

(function() {
    // EU country codes
    const euCountries = [
        'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
        'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
        'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB' // Including GB (UK) for GDPR compliance
    ];

    // Cookie management functions
    function setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    function getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Check if user has already consented
    const hasConsented = getCookie('gdpr-consent');
    if (hasConsented) {
        return; // User already gave consent, no need to show banner
    }

    // Function to create and show the GDPR notice
    function showGdprNotice() {
        // Create the notice container
        const noticeContainer = document.createElement('div');
        noticeContainer.className = 'gdpr-notice';
        noticeContainer.innerHTML = `
            <div class="gdpr-notice-content">
                <p>This website uses cookies to ensure you get the best experience. By continuing to use this site, you consent to our use of cookies in accordance with our Privacy Policy.</p>
                <div class="gdpr-notice-actions">
                    <button class="gdpr-accept-btn">Accept</button>
                    <button class="gdpr-decline-btn">Decline</button>
                </div>
            </div>
        `;

        // Add styles for the notice
        const style = document.createElement('style');
        style.textContent = `
            .gdpr-notice {
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.9);
                color: white;
                padding: 15px;
                z-index: 9999;
                font-size: 14px;
                transition: transform 0.3s ease-in-out;
            }
            .gdpr-notice-content {
                max-width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
            }
            .gdpr-notice-content p {
                margin: 0;
                padding: 5px 0;
                flex: 1;
            }
            .gdpr-notice-actions {
                display: flex;
                gap: 10px;
            }
            .gdpr-notice-actions button {
                padding: 8px 16px;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                font-weight: bold;
            }
            .gdpr-accept-btn {
                background-color: #4CAF50;
                color: white;
            }
            .gdpr-decline-btn {
                background-color: transparent;
                color: white;
                border: 1px solid white !important;
            }
            @media (max-width: 768px) {
                .gdpr-notice-content {
                    flex-direction: column;
                    text-align: center;
                }
                .gdpr-notice-actions {
                    margin-top: 10px;
                    justify-content: center;
                }
            }
        `;

        // Append the notice and styles to the document
        document.head.appendChild(style);
        document.body.appendChild(noticeContainer);

        // Add event listeners for the buttons
        const acceptBtn = noticeContainer.querySelector('.gdpr-accept-btn');
        const declineBtn = noticeContainer.querySelector('.gdpr-decline-btn');

        acceptBtn.addEventListener('click', function() {
            setCookie('gdpr-consent', 'accepted', 365); // Set cookie for 1 year
            noticeContainer.style.transform = 'translateY(100%)';
            setTimeout(() => {
                noticeContainer.remove();
                style.remove();
            }, 300);
        });

        declineBtn.addEventListener('click', function() {
            setCookie('gdpr-consent', 'declined', 365); // Set cookie for 1 year
            noticeContainer.style.transform = 'translateY(100%)';
            setTimeout(() => {
                noticeContainer.remove();
                style.remove();
            }, 300);
        });
    }

    // Check if we have the CF-IPCountry header available in a meta tag
    // This requires server-side code to add this meta tag
    function checkUserLocation() {
        const metaCountry = document.querySelector('meta[name="cf-ipcountry"]');
        if (metaCountry) {
            const countryCode = metaCountry.getAttribute('content');
            if (euCountries.includes(countryCode)) {
                showGdprNotice();
            }
        } else {
            // If we can't determine the country, show the notice to be safe
            showGdprNotice();
        }
    }

    // Initialize when DOM is fully loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkUserLocation);
    } else {
        checkUserLocation();
    }
})();